import { lazy } from 'react';

// Migration (Admin)

export const DeviceMigrationDashboard = lazy(() =>
  import('@/workflows/migration/pages/device/DeviceMigrationDashboard').then((m) => ({
    default: m.DeviceMigrationDashboard,
  }))
);

export const DeviceMigrationDetail = lazy(() =>
  import('@/workflows/migration/pages/device/DeviceMigrationDetail').then((m) => ({
    default: m.DeviceMigrationDetail,
  }))
);

export const DeviceMigrationWizard = lazy(() =>
  import('@/workflows/migration/pages/device/DeviceMigrationWizard').then((m) => ({
    default: m.DeviceMigrationWizard,
  }))
);

export const GWorkspaceMigrationWizard = lazy(() =>
  import('@/workflows/migration/pages/device/GWorkspaceMigrationWizard').then((m) => ({
    default: m.GWorkspaceMigrationWizard,
  }))
);

export const ProfileMigrationPage = lazy(() =>
  import('@/workflows/migration/pages/ProfileMigration').then((m) => ({ default: m.ProfileMigration }))
);
